import { render, staticRenderFns } from "./tree-slot.vue?vue&type=template&id=135d16ea&scoped=true"
import script from "./tree-slot.vue?vue&type=script&lang=js"
export * from "./tree-slot.vue?vue&type=script&lang=js"
import style0 from "./tree-slot.vue?vue&type=style&index=0&id=135d16ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135d16ea",
  null
  
)

export default component.exports